// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2y2KE","actionsCol":"EnrolledClinics_actionsCol__316uG"};